export const BRAND = {
  name: "Elevara",
  fullName: "Elevara by Innapax",
  tagline: "Elevate. Automate. Accelerate.",
  email: "elevarabyinnapax@gmail.com",
  phone: "(216) 526-5918",
  address: "United States",
  socials: {
    linkedin: "https://linkedin.com",
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    x: "https://x.com",
    youtube: "https://youtube.com",
  },
};

export const SERVICES = [
  {
    slug: "website-development",
    name: "Website Development",
    short: "Custom business websites, SaaS platforms, landing pages, and eCommerce solutions.",
    overview:
      "We design and engineer luxury web experiences that perform — from marketing sites to full-stack SaaS platforms. Every build is custom, performant, and crafted to convert.",
    benefits: [
      "Lighthouse 95+ performance baseline",
      "SEO-ready architecture",
      "Conversion-first design",
      "Scalable component system",
    ],
    deliverables: [
      "Design system + Figma source",
      "Production codebase (React / Next / FastAPI)",
      "CMS integration & content workflows",
      "Analytics + tracking",
      "Launch & 30-day post-launch support",
    ],
  },
  {
    slug: "app-development",
    name: "Mobile App Development",
    short: "iOS, Android, and cross-platform applications.",
    overview:
      "Native-quality mobile experiences built with React Native or native SDKs. From MVP to production at App Store scale.",
    benefits: [
      "Cross-platform shipping speed",
      "Native performance & feel",
      "App Store & Play Store delivery",
      "Push, payments, deep linking",
    ],
    deliverables: [
      "Mobile UX strategy",
      "iOS + Android builds",
      "Backend & API integration",
      "Store submission & approval",
    ],
  },
  {
    slug: "ai-automation",
    name: "AI Automation",
    short: "Chatbots, workflow automation, lead generation, CRM integrations, and AI agents.",
    overview:
      "Autonomous workflows that compound margin. We design AI agents, internal copilots, and integrated automations that replace manual operations.",
    benefits: [
      "60-80% manual workload reduction",
      "Custom GPT-class agent design",
      "CRM, email, and database integrations",
      "Human-in-the-loop safety",
    ],
    deliverables: [
      "Automation audit",
      "AI agent design & deployment",
      "Workflow integrations (n8n, Zapier, custom)",
      "Monitoring + handoff training",
    ],
  },
  {
    slug: "copyright-strategy",
    name: "Copyright Strategy",
    short: "Brand protection, digital asset registration guidance, and intellectual property strategy.",
    overview:
      "Lock down your digital assets. We guide founders through copyright registration, content protection, and IP strategy.",
    benefits: [
      "Defensible creative assets",
      "Reduced infringement risk",
      "Faster takedown enforcement",
    ],
    deliverables: [
      "Copyright audit",
      "Registration strategy",
      "Asset inventory & ownership documentation",
    ],
  },
  {
    slug: "trademark-strategy",
    name: "Trademark Strategy",
    short: "Brand protection, classification strategy, and multi-jurisdiction filings.",
    overview:
      "From class selection to global expansion: a strategic moat around your name, logo, and identity.",
    benefits: [
      "Strategic class & jurisdiction selection",
      "Long-term brand defensibility",
      "Reduced opposition risk",
    ],
    deliverables: [
      "Trademark availability search",
      "Filing strategy (USPTO + international)",
      "Brand asset documentation",
    ],
  },
  {
    slug: "benchmark-intelligence",
    name: "Benchmark & Market Intelligence",
    short: "Market research, competitor analysis, industry insights, and positioning.",
    overview:
      "McKinsey-style benchmarking, delivered with a startup's speed. We map the field so you can pick your battles.",
    benefits: [
      "Clear positioning roadmap",
      "Actionable competitor intel",
      "Pricing & packaging insight",
    ],
    deliverables: [
      "Competitive landscape report",
      "Positioning recommendations",
      "Market sizing & opportunity map",
    ],
  },
  {
    slug: "marketing-growth",
    name: "Marketing & Growth Solutions",
    short: "SEO, paid advertising, content marketing, community building, and customer acquisition.",
    overview:
      "Full-funnel growth engagements. Paid, organic, content, and community — engineered into one accountable engine.",
    benefits: [
      "Channel-mix optimization",
      "Premium-brand-safe growth tactics",
      "Compounding organic acquisition",
    ],
    deliverables: [
      "Growth strategy & forecast",
      "Paid ad management (Meta, Google, LinkedIn)",
      "Content & SEO program",
      "Community & lifecycle marketing",
    ],
  },
];

export const INDUSTRIES = [
  "Technology Startups",
  "Healthcare",
  "Professional Services",
  "Real Estate",
  "eCommerce",
  "Community Platforms",
];

export const TESTIMONIALS = [
  {
    quote:
      "Elevara rebuilt our entire growth stack. We tripled qualified pipeline in a quarter and finally have a system worth scaling.",
    author: "Marcus Chen",
    role: "CEO, Vantage Realty",
  },
  {
    quote:
      "The AI automation team replaced an entire SDR function. Quietly the best engineering partnership we've had.",
    author: "Priya Anand",
    role: "COO, Halo Health",
  },
  {
    quote:
      "Their benchmarking deck got us to Series A. The positioning work alone was worth the engagement.",
    author: "Jordan Wells",
    role: "Founder, Stellar SaaS",
  },
  {
    quote:
      "Premium feel, McKinsey-grade thinking, startup speed. Rare combination.",
    author: "Elena Rossi",
    role: "Managing Partner, Lumen Legal",
  },
];

export const TIMELINE = [
  { year: "2022", title: "Foundation", desc: "Innapax founded with a focus on premium technology consulting." },
  { year: "2023", title: "First Clients", desc: "Delivered flagship platforms across healthcare and SaaS." },
  { year: "2024", title: "Expansion", desc: "Scaled growth marketing and intellectual property practices." },
  { year: "2025", title: "AI Automation Division", desc: "Launched dedicated AI agents practice for enterprise clients." },
  { year: "2026+", title: "Future Growth Initiatives", desc: "Global expansion and product venture studio." },
];
